import React from 'react';
import DashboardFunctional from './components/dashboard-functional';
import './styles.scss';

const Dashboard = () => {
	return <DashboardFunctional />;
};

export default Dashboard;
